import { Component } from "@angular/core";

@Component({
    selector: "app-plain-layout",
    templateUrl: "./plain-layout.component.html",
    styleUrl: "./plain-layout.component.scss",
    standalone: false,
})
export class PlainLayoutComponent {}
